import React, { useState, useEffect } from 'react'
import { formatCurrency, getCurrencyByLocale } from 'utils/currencyHelper'
import { getCookie, isEmpty, isUserSignedIn } from 'utils/browserHelper'
import { Stencil } from '@cleartrip/bento'
import { useHistory } from 'react-router'
import WalletLogo from 'assets/icons/walletHome.svg'
import { getWalletInfo } from 'utils/apiHelper.js'
import Clevertap from 'analytics'
import { getLocaleByCurrency } from 'utils/currencyHelper.js'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import { DOMAIN } from 'constants/base'

const Wallet = ({ abTest, walletBalance, walletLoading }) => {
    const browserHistory = useHistory()
    const signedIn = isUserSignedIn()
    const locale = getLocaleByCurrency('SAR')
    const handleClick = () => {
        if (signedIn) {
            window.location.href = '/accounts/wallet'
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'hp_wallet_click',
                wallet_balance: walletBalance,
                wallet_icon_displayed: abTest && abTest?.wallet_display && abTest?.wallet_display === 'b' ? 'yes' : 'no'
            })
        }
    }

    return signedIn && DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' ? (
        <>
            {walletLoading ? (
                <Stencil shimmer={true} height="15px" width="75px" />
            ) : walletBalance || walletBalance === 0 ? (
                <div
                    className="fs-14 lh-16 c-#1A1A1A fw-600"
                    style={{
                        marginRight: '16px',
                        cursor: 'pointer',
                        display: 'flex'
                    }}
                    onClick={handleClick}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={WalletLogo} />
                    </div>
                    {Number(walletBalance) === 0 ? (
                        <span className="fs-3" style={{ marginLeft: '12px', fontWeight: '400', lineHeight: '16px' }}>
                            {parseInt(walletBalance).toLocaleString(locale, {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 0
                            })}
                        </span>
                    ) : (
                        <span className="ml-3 fs-3" style={{ fontWeight: '400', lineHeight: '16px' }}>
                            {formatCurrency({
                                price: Number(walletBalance.toString().replace(/,/g, '')),
                                rate: Number(walletBalance.toString().replace(/,/g, '')),
                                currencyCode: 'INR',
                                sellingRate: Number(walletBalance.toString().replace(/,/g, ''))
                            })}
                        </span>
                    )}
                </div>
            ) : null}
        </>
    ) : null
}

export default Wallet
